import React from 'react';

/**
 * The signup v2 analytics (`createOnboardingAnalytics`) and the current step, for the shared
 * components (layout, mobile preview) that the steps don't pass them to.
 */
export const SignupAnalyticsContext = React.createContext({ analytics: null, stepName: null });
